const PAYMENT_PAGE = `${location.origin}/razmestit-obyavlenie/payment/`;
const RETURN_URL = `${location.origin}/razmestit-obyavlenie/payment/success/`;

export interface IGetIframeUrlSettings {
  shopId: number;
  scId: number;
  customerNumber: string;
  sum: number;
  paymentType: string;
  host: string;
  clientOrderId: string;
  confirmationToken: string;
}

export interface IGetIframeUrlParams {
  $sce: angular.ISCEService;
  settings: IGetIframeUrlSettings;
  isYandexKassaV2Enabled: boolean;
}

export const getIframeUrl = (params: IGetIframeUrlParams) => {
  const { $sce, isYandexKassaV2Enabled } = params;

  let urlParams;
  let hostName;

  if (isYandexKassaV2Enabled) {
    const { confirmationToken } = params.settings;

    hostName = PAYMENT_PAGE;

    urlParams = [
      `confirmationToken=${confirmationToken}`,
      `returnUrl=${RETURN_URL}`,
    ].join('&');
  } else {
    const { clientOrderId, shopId, scId, customerNumber, sum, paymentType, host } = params.settings;

    hostName = host;

    urlParams = [
      `ShopID=${$sce.trustAsHtml(shopId)}`,
      `scid=${$sce.trustAsHtml(scId)}`,
      `sum=${$sce.trustAsHtml(sum)}`,
      `paymentType=${$sce.trustAsHtml(paymentType)}`,
      `customerNumber=${$sce.trustAsHtml(customerNumber)}`,
      `clientOrderId=${clientOrderId}`,
    ].join('&');
  }

  return $sce.trustAsResourceUrl(`${hostName}?${urlParams}`);
};
